export default __webpack_public_path__ + "static/media/CountingOverview.c33a61aa.svg";